import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Brand } from '@app/core/interfaces';
import { BrandService } from '@app/core/services';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-marque-form',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MessageModule,
    ButtonModule,
    InputTextModule,
    FloatLabelModule,
  ],
  providers: [
    MessageService
  ],
  templateUrl: './marque-form.html'
})
export class MarqueForm implements OnInit, OnDestroy {
  @Input() brand!: Brand;

  private destroy$: Subject<any> = new Subject();
  
  isSendingDatas = false;
  brandForm: FormGroup = new FormGroup({
    nom: new FormControl(null, [Validators.required])
  });

  constructor(
    private dialogRef: DynamicDialogRef,
    private brandService: BrandService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.brandForm.patchValue(this.brand)
  }

  hideDialog(): void {
    this.isSendingDatas = false;
    this.dialogRef.close(this.brand.id ? this.brand : null);
  }

  onSubmit() {
    this.brandForm.disable();
    const data = this.brandForm.value;
    
    this.brand = {
      ...this.brand,
      nom: data.nom.trim(),
    };
    this.onSave();
  }

  onSave() {
    this.isSendingDatas = true;
    let observable: Observable<Brand>;
    let messageOption: ToastMessageOptions;

    if (this.brand?.id) {
      observable = this.brandService.patch(this.brand.id, this.brand);
      messageOption = {severity: 'info', summary: `Modification d'une marque`, detail: `La modification de la marque a été complété avec succès!`}
    } else {
      observable = this.brandService.post(this.brand);
      messageOption = {severity: 'success', summary: `Création d'une marque`, detail: `La création de la marque a été complété avec succès!`}
    }

    observable
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: Brand) => {
          this.brand = response;
          this.messageService.add(messageOption);
          this.isSendingDatas = false;
        },
        complete: () => this.hideDialog(),
        error: () => this.isSendingDatas = false
      });
  }

  ngOnDestroy(): void {
    if (this.destroy$) {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
  }
}
